export const columnsData = [
  {
    Header: "Name",
    accessor: "itemName",
  },
  {
    Header: "Price",
    accessor: "itemPrice",
  },
  {
    Header: "Image",
    accessor: "itemImage",
  },
];
